import {UyapRequest} from "./UyapRequest";

export interface MtsIcraTakipBaslatTalep {
    alacakliKisiKurumId: string,
    dosyaId: string | number,
    icraTakipSebepId: string,
    kotaTur: string,
    odemeTipi: "4" | "7",     // {"4":"Vakıfbank","7":"e-barobirlik kart"}
}

export interface MtsIcraTakipBaslatCevap {
    type: string,
    message: string,
    log: string
}

export default class MtsIcraTakipBaslat extends UyapRequest<MtsIcraTakipBaslatTalep, MtsIcraTakipBaslatCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "MTS icra takip başlatılıyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return {
            "type": "success",
            "message": "Ankara Batı İcra Dairesi 2019/111TEST dosya no ile icra takip dosyanız oluşturulmuştur! Lütfen ilgili dosyaya evrak gönderme işlemini tamamlayınız!",
            "log": ""
        };
        // Hata response
        // return {"errorCode":"PRTL_GNL_1000600", "error":"Ödeme yapılırken hata oluştu. "}
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'mts_icra_takip_baslat_brd.ajx';
    }

    async parse(data: any): Promise<MtsIcraTakipBaslatCevap> {
        return data;
    }

}
